'use client';

import { singleProject } from 'enteties/project/api';
import { Skeleton } from 'shared/ui/skeleton';
import { StatusChip } from '@/enteties/project/ui';
import { useQueryWithOnError } from 'shared/hooks/query/useQueryWithOnError';
interface StatusLoadProps {
  slug: string;
}
const StatusLoad = ({
  slug
}: StatusLoadProps) => {
  const {
    data: project,
    isLoading,
    isSuccess
  } = useQueryWithOnError({
    ...singleProject.getSingleProjectQueryOptions({
      slug
    })
  });
  if (isLoading) return <StatusLoadSkeleton slug={slug} />;
  if (!isSuccess) return <StatusLoadSkeleton slug={slug} />;
  return <div className="flex flex-start md:justify-center h-8 flex-row items-center gap-6" data-sentry-component="StatusLoad" data-sentry-source-file="status-load.tsx">
      <h1 className="mb-1 align-middle text-title1 font-medium">{slug}</h1>
      <StatusChip status={project?.status} data-sentry-element="StatusChip" data-sentry-source-file="status-load.tsx" />
    </div>;
};
const StatusLoadSkeleton = ({
  slug
}: StatusLoadProps) => {
  return <div className=" flex h-8 flex-row items-center justify-center gap-6" data-sentry-component="StatusLoadSkeleton" data-sentry-source-file="status-load.tsx">
      <h1 className="mb-1 align-middle text-title1 font-medium">{slug}</h1>
      <Skeleton className="h-6 w-24 rounded-full bg-accent" data-sentry-element="Skeleton" data-sentry-source-file="status-load.tsx" />
    </div>;
};
export { StatusLoad, StatusLoadSkeleton };